import { Card, CardContent, Checkbox, Grid } from '@mui/material';
import React from 'react'
import { bulletStyle, listItemStyle } from '../../../globalcss/globalStyle';
import checkCircle from "../../../assets/images/checkCircle.png";

const SuggestPlanDetails = ({ isuggestPlan, checkBoxChecked, setCheckBoxChecked, planCardRef, showOtherPlan, selectedPlan }) => {
    return (
        <div>
            {isuggestPlan && isuggestPlan.suggestPlan !== 'undefined' ?
                <div ref={planCardRef} style={{ overflowY: "auto", position: 'relative', cursor: 'pointer', minWidth: '300px' }} className={`plan-card ${showOtherPlan ? 'show' : ''}`}>
                    <Grid container>
                        <Grid item xs={12} sm={12}>
                            <Card style={{ border: '0.5px solid grey', marginTop: '10px' }}>
                                <CardContent>
                                    <div className="plain-wrapper">
                                        <div className="text">  {isuggestPlan.plan} @ ₹{isuggestPlan.afterDiscount.toLocaleString()} <span className="gst-text">+GST</span></div>
                                        {isuggestPlan.price <= isuggestPlan.afterDiscount ? null : <div className="save">    Save {Math.floor(((isuggestPlan.price - isuggestPlan.afterDiscount) / isuggestPlan.price) * 100)}%</div>
                                        }
                                    </div>
                                    <div

                                        sx={{ fontSize: "15px", fontWeight: 400, lineHeight: "16px", marginTop: '5px' }}
                                        color="primary.dark"
                                    >
                                        {isuggestPlan.description && isuggestPlan.description}
                                    </div>
                                    <div className="border-bottom"></div>
                                    <div className="price-wrapper">
                                        <h6 style={{ margin: '10px 0px', fontWeight: 'bold', fontSize: '15px' }}>Benefits</h6>
                                        <Grid container >
                                            <Grid item xs={12} sm={6}> {/* On mobile (xs), it will take full width. On small screens (sm), it will take half the width. */}
                                                <ul style={{ marginLeft: '-22px', marginBottom: '0rem' }}>
                                                    {isuggestPlan &&
                                                        isuggestPlan.benefits.slice(0, isuggestPlan.benefits.length / 2).map((benefit, index) => (
                                                            <li key={index} style={listItemStyle}>
                                                                <span style={bulletStyle}>
                                                                    <img className='image-benefits' src={checkCircle} alt="check-circle" />
                                                                </span>
                                                                <div className='benefits'> {benefit}</div>
                                                            </li>
                                                        ))}
                                                </ul>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <ul style={{ marginLeft: '-22px' }}>
                                                    {isuggestPlan &&
                                                        isuggestPlan.benefits.slice(isuggestPlan.benefits.length / 2).map((benefit, index) => (
                                                            <li key={index} style={listItemStyle}>
                                                                <span style={bulletStyle}>
                                                                    <img className='image-benefits' src={checkCircle} alt="check-circle" />
                                                                </span>
                                                                <div className='benefits'> {benefit}</div>
                                                            </li>
                                                        ))}
                                                </ul>
                                            </Grid>
                                        </Grid>
                                    </div>
                                    <div className="product-details-card-wrapper">
                                        <div className="product-details-price">
                                            <div className="price-row">
                                                <div className="price-row-wrapper">
                                                    <div className="cut-price-after">₹{isuggestPlan.afterDiscount.toLocaleString()}</div>
                                                </div>
                                                <div className="cut-price">
                                                    <Checkbox
                                                        checked={checkBoxChecked}
                                                        onChange={(e) => {
                                                            setCheckBoxChecked(e.target.checked);
                                                        }}
                                                        inputProps={{ 'aria-label': 'checkbox' }}
                                                    />
                                                    <span className='custom-text'>
                                                        Yes, I want the {isuggestPlan && isuggestPlan.plan}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </div> : null
            }
        </div>
    )
}

export default SuggestPlanDetails